import {useEffect, useState} from "react";
import {withTranslation} from "react-i18next";
import "../ceiba.scss";
import {Button, Modal} from 'antd';

import {CheckCircleOutlined, LogoutOutlined,PlayCircleOutlined } from '@ant-design/icons';
import {Progress} from 'antd';
import {history} from "../../../../_helpers";
import MiDiploma from "./worlds/miDiploma";

import WorldCeiba from "./worlds/ceiba";
import WorldCervo from "../cervo/steps/worlds/cervo";
import Nogam3Preview from "../nogam/nogam3/startPreview";
import Nogam4Preview from "../nogam/nogam4/startPreview4";
import Nogam5Preview from "../nogam/nogam5/startPreview5";
import Nogam6Preview from "../nogam/nogam6/startPreview6";
import {xcService} from "../../../../_services/xcService";
import * as _ from "lodash";
import {useDispatch} from "react-redux";
import localOrSessionStore from "../../../../_helpers/localOrSessionStore";
import variables from "../../../../_constants/variables";
import endpoint from "shared/endpoints";

function StepTwo(props) {

    const {t, i18n} = props;
    const dispatch = useDispatch();
    const [answers, setAnswers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [userQuest, setUserQuest] = useState();
    const [code, setCode] = useState();
    const [course, setCourse] = useState();
    const [questionnaires, setQuestionnaires] = useState([]);
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const user = JSON.parse(storage.getItem(variables.USER));
    const userType = storage.getItem(variables.USER_TYPE);
    const [noGame, setNoGame] = useState(0);
    const [loaded, setLoaded] = useState(false)
    const [totalTek, setTotalTek] = useState(-2);
    const [preguntasTek, setPreguntasTek] = useState(-1);
    const [ceibaFinish, setCeibaFinish] = useState(false)
    const [cervoFinish, setCervoFinish] = useState(false)
    const [showVideo, setShowVideo] = useState(false);
    const setQuest = (course) => {
        const quests = {
            '3º ESO': 'TEK3ESO',
            '4º ESO': 'TEK4ESO',
            '1º Bachillerato': 'TEK1BAC',
            '2º Bachillerato': 'TEK2BAC',
            'FP Grado Básico': 'TEKFPB',
            'FP Grado Medio': 'TEKFPM',
        }

        setUserQuest(quests[course])

    }


    const items1 = {
        '3º ESO': 4,
        '4º ESO': 6,
        '1º Bachillerato': 7,
        '2º Bachillerato': 7,
        'FP Grado Básico': 5,
        'FP Grado Medio': 5,
    }

    const items2 = {
        '3º ESO': 14,
        '4º ESO': 14,
        '1º Bachillerato': 13,
        '2º Bachillerato': 10,
        'FP Grado Básico': 11,
        'FP Grado Medio': 10,
    }
    const items3 = {
        '3º ESO': 8,
        '4º ESO': 7,
        '1º Bachillerato': 11,
        '2º Bachillerato': 8,
        'FP Grado Básico': 6,
        'FP Grado Medio': 6,
    }

    useEffect(() => {
        if (user.firstTime) {
            setShowVideo(true)
        }

    }, [user])

    useEffect(() => {

        getAreas();


        xcService.getToken('/v1/student/course').then(({data}) => {
            setQuest(data?.data?.name);
            setCourse(data?.data?.name)
        })
    }, [])

    const getAreas = async () => {
        await xcService.getToken('/v1/year').then(async ({ data }) => {
            let mYear = (+data.data)

            const areaPath = `/v1/student/area/CEIBA?year=${mYear}`
            await xcService.getToken(areaPath).then(({data}) => {
                setCeibaFinish(!!data.data );
            });

            const areaCevoPath = `/v1/student/area/CERVO?year=${mYear}`
            await xcService.getToken(areaCevoPath).then(({data}) => setCervoFinish(!!data.data));

        });
    }

    const getResponsesUser = async () => {
        let apiEndpointR = endpoint.studentAnswer.getAll(userQuest);
        const answersQ = await xcService.getToken(apiEndpointR);
        setTotalTek(answersQ ? answersQ.data?.data?.length : -1)

        let apiEndpoint = "/v1/student/assessments/" + userQuest;
        const responseQ = await xcService.getToken(apiEndpoint);
        setPreguntasTek(responseQ.data.data?.length === 0 ? -1 : responseQ.data.data?.length)


        setLoaded(true);

        const questionPath = `/v1/student/myquestionnaires`;
        xcService.getToken(questionPath).then(({data}) => {


            let mNoGame = 0;
            setQuestionnaires(data.data)
            let mNoGame3 = _.filter(
                data.data, function (o) {
                    return o.code === 'NOGAM3';
                }
            );

            if (mNoGame3 && mNoGame3[0] && mNoGame3[0].totresp === mNoGame3[0].tota) {
                mNoGame++;

            }

            let mTemp = _.filter(
                data.data, function (o) {
                    return o.code === 'NOGAM4';
                }
            );
            if (mTemp && mTemp[0] && mTemp[0].totresp === mTemp[0].tota) {
                mNoGame++;
            }


            mTemp = _.filter(
                data.data, function (o) {

                    return o.code === 'NOGAM5';
                }
            );
            if (mTemp && mTemp[0] && mTemp[0].totresp === mTemp[0].tota) {
                mNoGame++;
            }


            mTemp = _.filter(
                data.data, function (o) {
                    return o.code === 'NOGAM6';
                }
            );
            if (mTemp && mTemp[0] && mTemp[0].totresp === mTemp[0].tota) {

                mNoGame++;
            }

            setNoGame(mNoGame)


        })
    }
    useEffect(() => {
        if (!userType) return;

        getResponsesUser();


    }, [userType, course, userQuest]);


    const closeVideo = () => {
        user.firstTime = false;
        storage.setItem(variables.USER, JSON.stringify(user));
        setShowVideo(false)
        setShowModal(user.noName)

    }
    return (
        <div className={"containerCeibaNormal"}>
            <Modal className={"modalName modal-question modal-question--xs modal-fortalezas"}
                   title={t("world.fortalezas")} visible={showModal} onOk={() => console.info('Clicked ok')}
                   onCancel={() => setShowModal(false)}>
                <div className={"diNombre"}>
                    <Nogam3Preview/>
                    <Nogam4Preview/>
                    <Nogam5Preview/>
                    <Nogam6Preview/>
                </div>
            </Modal>

            {showVideo &&


                <Modal className={"modalNameVideo"} title={t("home.welcomeo")} width={"100%"} heigth={"100%"}
                       visible={showVideo}
                       onOk={closeVideo} onCancel={closeVideo}>
                    <iframe id="kaltura_player"
                            className={"onboarding-player-iframe"}
                            src="https://cdnapisec.kaltura.com/p/2206521/sp/220652100/embedIframeJs/uiconf_id/42503771/partner_id/2206521?iframeembed=true&playerId=kaltura_player&entry_id=1_kntaza1l&flashvars[streamerType]=auto&amp;flashvars[localizationCode]=es&amp;flashvars[leadWithHTML5]=true&amp;flashvars[sideBarContainer.plugin]=true&amp;flashvars[sideBarContainer.position]=left&amp;flashvars[sideBarContainer.clickToClose]=true&amp;flashvars[chapters.plugin]=true&amp;flashvars[chapters.layout]=vertical&amp;flashvars[chapters.thumbnailRotator]=false&amp;flashvars[streamSelector.plugin]=true&amp;flashvars[EmbedPlayer.SpinnerTarget]=videoHolder&amp;flashvars[dualScreen.plugin]=true&amp;flashvars[hotspots.plugin]=1&amp;flashvars[Kaltura.addCrossoriginToIframe]=true&amp;&wid=1_r5vyitk6"
                            allowFullScreen webkitallowfullscreen mozAllowFullScreen
                            allow="autoplay *; fullscreen *; encrypted-media *"
                            sandbox="allow-downloads allow-forms allow-same-origin allow-scripts allow-top-navigation allow-pointer-lock allow-popups allow-modals allow-orientation-lock allow-popups-to-escape-sandbox allow-presentation allow-top-navigation-by-user-activation"
                            frameBorder="0" title="TEASER"></iframe>

                </Modal>
            }
            <div className={"boxed"}>
                <div className={"insideCeiba boxed"}>
                    <Button onClick={() => history.push("/admin/dashboard")} className="primaryButton btn-icon-text"
                            icon={<LogoutOutlined/>}>{t("ceiba.exit")}</Button>
                    <Button className="primaryButton btn-icon-text" onClick={() => setShowVideo(true)}
                            icon={<PlayCircleOutlined />}>{t("historiae")}</Button>
                </div>
                <div className={"container"}>
                    <div className={"selectQ fortalezas"}>
                        <div className={"wrapper"}>
                            <div>
                                <p>{t("world.stepfortalezas")}</p>
                                <h2>{t("world.fortalezas")}</h2>
                            </div>
                            <h3 dangerouslySetInnerHTML={{__html: t("world.otros")}}/>
                            <Button
                                type={"primary"}
                                className="buttonSizeXM btnBorder"
                                onClick={() => setShowModal(true)}
                            >
                                {t("enter")}
                            </Button>
                            {noGame === 4 ?
                                <div className={"posend"}>
                                    <CheckCircleOutlined style={{fontSize: 40}}/>
                                </div> :

                                <div className={"posend"}>
                                    <Progress width={50} type="circle" percent={((noGame * 100) / 4)}
                                              format={() => noGame + "/4"}/>
                                </div>

                            }


                        </div>
                        <Button  onClick={() => setShowModal(true)}
                            type={"primary"}
                            className="btnBorder is-mobile-wh"
                        >
                            {t("world.motros")}  {noGame === 4 && <div className={"posendmobile"}>
                            <CheckCircleOutlined style={{fontSize: 14}} /></div>}

                        </Button>
                    </div>


                    <WorldCeiba finish={ceibaFinish} />
                    <WorldCervo  finish={cervoFinish} />

                    <div className={"selectQ tek"}>
                        <div className={"wrapper"}>
                            <div>
                                <p>{t("world.steptek")}</p>
                                <h2>{t("world.tek")}</h2>
                            </div>
                            <h3>{t("world.desctek")}</h3>
                            <Button
                                type={"primary"}
                                className="buttonSizeXM btnBorder"
                                onClick={() => history.push(+totalTek === +preguntasTek ? "/admin/finish-tek"  :"/admin/tek")}
                            >
                                {t("enter")}
                            </Button>

                            {!loaded ?
                                <div className={"posend"}>
                                    <Progress width={50} type="circle" percent={((0 * 100) / (preguntasTek))}
                                              format={() => ""}/>
                                </div> :
                                    totalTek === preguntasTek ?
                                        <div className={"posend"}>
                                            <CheckCircleOutlined style={{fontSize: 40}}/>
                                        </div> :

                                        <div className={"posend"}>
                                            <Progress width={50} type="circle" percent={((totalTek * 100) / (preguntasTek))}
                                                      format={() => ""}/>
                                        </div>
                            }


                        </div>
                        <Button  onClick={() => history.push(+totalTek === +preguntasTek ? "/admin/finish-tek"  :"/admin/tek")}
                            type={"primary"}
                            className="btnBorder is-mobile-wh"
                        >

                            {t("world.mtek")}
                            {totalTek === preguntasTek &&
                                <div className={"posendmobile"}>
                                    <CheckCircleOutlined style={{fontSize: 14}}/>
                                </div>
                            }
                        </Button>
                    </div>

                    <MiDiploma/>
                </div>
            </div>
        </div>

    )
}

export default withTranslation()(StepTwo);
